import _defineProperty from "/src/main/react/node_modules/@babel/runtime/helpers/esm/defineProperty.js";
var _jsxFileName = "/src/main/react/src/main/app/components/pages/SearchResult.js";
import React from 'react';
import { Grid, Paper, AppBar, Typography, Tabs, Tab, Chip, Button } from '@material-ui/core';
import { withStyles } from '@material-ui/core/styles';
import { withRouter } from 'react-router-dom';
import TpicPage from './TpicPage';
import ImageTable from '../images/ImageTable';
import Footer from '../navigation/Footer';
import queryString from "query-string";
import Util from "../../util/Util";
import { EntityInfo, SimpleSnackbar } from '../common';
import { EntitySelected } from "./index";
import { BASE_URIS, DISPLAY_IMAGES, ID_SPACE, IMAGETABLE_DESCRIPTIONS, LOCAL_STORAGE_ITEM_NAMES, Q_STRING, TPIS_CAPABILITIES as CAPS } from "../domain/constants";
import { changeSearchValue, changeSearchValues, retrieveFromQueryString, setUpTabInfoFromQueryString } from "../../util/QueryStringUtil";
import { stringToList } from "../../util/StringUtil";
import { fillInEntityInfo } from "../../util/APIUtil";
import { UPDATE_PROGRAM } from "../Routes";
const styles = () => ({
  centeredContainer: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    margin: '0 auto',
    maxWidth: '80vw',
    minWidth: '80vw'
  }
});
class SearchResult extends TpicPage {
  constructor(props) {
    super(props);
    _defineProperty(this, "handleChange", (event, value) => {
      this.setState({
        value
      });
      let params = {};
      params[Q_STRING.TAB] = value;
      params[Q_STRING.PAGE] = 1;
      changeSearchValues(params, this.props);
    });
    const querystringValues = queryString.parse(props.location.search);
    const tab = EntitySelected.determineTabValueFromQueryString(querystringValues);
    this.state = {
      value: tab !== -1 ? tab : 0,
      entityId: props.entityId != null ? props.entityId : retrieveFromQueryString(Q_STRING.ENTITY_ID, querystringValues),
      entityProvider: props.namespace != null ? props.namespace : retrieveFromQueryString(Q_STRING.PROVIDER, querystringValues),
      title: props.title != null ? props.title : this.retrieveAndDecodeTitle(querystringValues),
      subtitle: null,
      adiId: '',
      merlinId: '',
      selectedImages: DISPLAY_IMAGES.new,
      lookupComplete: false,
      type: null,
      partnerOwnerId: localStorage.getItem(LOCAL_STORAGE_ITEM_NAMES.partnerOwnerId)
    };
    if (tab === -1) {
      changeSearchValue(Q_STRING.TAB, 0, props);
    }
    fillInEntityInfo(this);
    this.snackbar = null;
    this.setSnackbarRef = element => {
      this.snackbar = element;
    };
  }
  retrieveAndDecodeTitle(querystringValues) {
    const encoded = retrieveFromQueryString(Q_STRING.TITLE, querystringValues);
    let decoded = encoded;
    try {
      decoded = decodeURIComponent(encoded);
    } catch (err) {
      if (err.name === "URIError") {
        console.warn("".concat(encoded, " is either malformed or is already decoded"));
      }
    }
    return decoded;
  }
  componentDidMount() {
    if (this.state.value === 0) {
      this.determineShouldDefaultToLegacyImages();
    }
  }
  componentDidUpdate(prevProps, prevState, snapshot) {
    if (prevProps.location.search !== this.props.location.search) {
      const querystringValues = queryString.parse(this.props.location.search);

      // If the user was already on the search page and they searched for something else, we need to complete that search here
      // However props.location.search includes tab and page info, and if that changes, it can trigger the new search as well
      let entityIdFromQueryString = retrieveFromQueryString(Q_STRING.ENTITY_ID, querystringValues);
      let entityProviderFromQueryString = retrieveFromQueryString(Q_STRING.PROVIDER, querystringValues);
      let titleFromQueryString = this.retrieveAndDecodeTitle(querystringValues);
      if (this.state.entityId !== entityIdFromQueryString || this.state.entityProvider !== entityProviderFromQueryString) {
        let adiId = '';
        let merlinId = '';
        if (entityProviderFromQueryString === ID_SPACE.ADI) {
          adiId = entityIdFromQueryString;
        } else if (entityProviderFromQueryString === ID_SPACE.MERLIN) {
          merlinId = entityIdFromQueryString;
        }
        this.setState({
          entityId: entityIdFromQueryString,
          entityProvider: entityProviderFromQueryString,
          title: titleFromQueryString,
          adiId: adiId,
          merlinId: merlinId,
          type: null
        });
      }

      // Determine proper tab value
      const defaultValue = 0;
      const tabValueFromQString = EntitySelected.determineTabValueFromQueryString(querystringValues);
      setUpTabInfoFromQueryString(this, prevState, defaultValue, querystringValues, tabValueFromQString);
    }
    if (this.state.lookupComplete === false && this.state.entityProvider !== prevState.entityProvider || this.state.entityId !== prevState.entityId) {
      fillInEntityInfo(this);
    }
  }
  render() {
    const classes = this.props.classes;
    const _this$state = this.state,
      value = _this$state.value,
      selectedImages = _this$state.selectedImages,
      partnerOwnerId = _this$state.partnerOwnerId;
    const caps = stringToList(localStorage.getItem(LOCAL_STORAGE_ITEM_NAMES.capabilities));
    const key = "".concat(this.state.entityProvider, "-").concat(this.state.entityId, "-").concat(this.state.title, "-").concat(this.state.type);
    return /*#__PURE__*/React.createElement("div", {
      id: "grid-container",
      className: classes.centeredContainer,
      __self: this,
      __source: {
        fileName: _jsxFileName,
        lineNumber: 153,
        columnNumber: 13
      }
    }, /*#__PURE__*/React.createElement(SimpleSnackbar, {
      ref: this.setSnackbarRef,
      __self: this,
      __source: {
        fileName: _jsxFileName,
        lineNumber: 154,
        columnNumber: 17
      }
    }), /*#__PURE__*/React.createElement(Grid, {
      container: true,
      alignContent: "center",
      direction: "column",
      spacing: 1,
      justify: "space-around",
      __self: this,
      __source: {
        fileName: _jsxFileName,
        lineNumber: 155,
        columnNumber: 17
      }
    }, /*#__PURE__*/React.createElement(Grid, {
      item: true,
      __self: this,
      __source: {
        fileName: _jsxFileName,
        lineNumber: 156,
        columnNumber: 21
      }
    }, /*#__PURE__*/React.createElement(EntityInfo, {
      key: key,
      merlinId: this.state.merlinId,
      title: this.state.title,
      subtitle: this.state.subtitle,
      adiId: this.state.adiId,
      type: this.state.type,
      __self: this,
      __source: {
        fileName: _jsxFileName,
        lineNumber: 157,
        columnNumber: 25
      }
    })), partnerOwnerId != null && /*#__PURE__*/React.createElement(Grid, {
      item: true,
      className: classes.centeredContainer,
      __self: this,
      __source: {
        fileName: _jsxFileName,
        lineNumber: 166,
        columnNumber: 21
      }
    }, /*#__PURE__*/React.createElement(Button, {
      variant: "contained",
      color: "primary",
      onClick: () => {
        let path = this.makePath();
        this.props.history.push(path);
      },
      elevation: 0,
      __self: this,
      __source: {
        fileName: _jsxFileName,
        lineNumber: 167,
        columnNumber: 25
      }
    }, "Update Program Info")), /*#__PURE__*/React.createElement(Grid, {
      item: true,
      container: true,
      direction: "column",
      alignContent: "center",
      justify: "center",
      spacing: 5,
      key: key,
      __self: this,
      __source: {
        fileName: _jsxFileName,
        lineNumber: 173,
        columnNumber: 21
      }
    }, /*#__PURE__*/React.createElement(Grid, {
      item: true,
      __self: this,
      __source: {
        fileName: _jsxFileName,
        lineNumber: 175,
        columnNumber: 25
      }
    }, /*#__PURE__*/React.createElement(Paper, {
      elevation: 0,
      __self: this,
      __source: {
        fileName: _jsxFileName,
        lineNumber: 176,
        columnNumber: 29
      }
    }, /*#__PURE__*/React.createElement(AppBar, {
      position: "sticky",
      __self: this,
      __source: {
        fileName: _jsxFileName,
        lineNumber: 177,
        columnNumber: 33
      }
    }, /*#__PURE__*/React.createElement(Tabs, {
      value: value,
      variant: "scrollable",
      onChange: this.handleChange,
      style: {
        overflow: 'hidden'
      },
      __self: this,
      __source: {
        fileName: _jsxFileName,
        lineNumber: 179,
        columnNumber: 37
      }
    }, /*#__PURE__*/React.createElement(Tab, {
      label: "All",
      value: 0,
      __self: this,
      __source: {
        fileName: _jsxFileName,
        lineNumber: 181,
        columnNumber: 41
      }
    }), caps != null && Util.isVisibleForCapabilities(caps, [CAPS.AUDIT]) && /*#__PURE__*/React.createElement(Tab, {
      label: "Audit Pending",
      value: 1,
      __self: this,
      __source: {
        fileName: _jsxFileName,
        lineNumber: 183,
        columnNumber: 41
      }
    }), caps != null && Util.isVisibleForCapabilities(caps, [CAPS.AUDIT, CAPS.READ]) && [/*#__PURE__*/React.createElement(Tab, {
      label: "Accepted",
      value: 2,
      __self: this,
      __source: {
        fileName: _jsxFileName,
        lineNumber: 187,
        columnNumber: 45
      }
    }), /*#__PURE__*/React.createElement(Tab, {
      label: "Rejected",
      value: 3,
      __self: this,
      __source: {
        fileName: _jsxFileName,
        lineNumber: 188,
        columnNumber: 45
      }
    })], caps != null && Util.isVisibleForCapabilities(caps, [CAPS.PUBLISH]) && /*#__PURE__*/React.createElement(Tab, {
      label: "Publish Pending",
      value: 4,
      __self: this,
      __source: {
        fileName: _jsxFileName,
        lineNumber: 191,
        columnNumber: 41
      }
    }), caps != null && Util.isVisibleForCapabilities(caps, [CAPS.PUBLISH]) && /*#__PURE__*/React.createElement(Tab, {
      label: "Publish Failed",
      value: 6,
      __self: this,
      __source: {
        fileName: _jsxFileName,
        lineNumber: 194,
        columnNumber: 41
      }
    }), /*#__PURE__*/React.createElement(Tab, {
      label: "Published",
      value: 5,
      __self: this,
      __source: {
        fileName: _jsxFileName,
        lineNumber: 196,
        columnNumber: 41
      }
    }), /*#__PURE__*/React.createElement(Tab, {
      label: "Existing",
      value: 7,
      __self: this,
      __source: {
        fileName: _jsxFileName,
        lineNumber: 197,
        columnNumber: 41
      }
    }))), value === 0 && selectedImages === DISPLAY_IMAGES.new && [this.getNewLegacyChips(), /*#__PURE__*/React.createElement(ImageTable, {
      baseUri: BASE_URIS.listImages,
      entityId: this.state.entityId,
      entityProvider: this.state.entityProvider,
      merlinId: this.state.merlinId,
      adiId: this.state.adiId,
      description: IMAGETABLE_DESCRIPTIONS.all,
      title: this.state.title,
      __self: this,
      __source: {
        fileName: _jsxFileName,
        lineNumber: 203,
        columnNumber: 37
      }
    })], value === 0 && selectedImages === DISPLAY_IMAGES.legacy && [this.getNewLegacyChips(), /*#__PURE__*/React.createElement(ImageTable, {
      baseUri: BASE_URIS.listLegacyImages,
      entityId: this.state.entityId,
      entityProvider: this.state.entityProvider,
      merlinId: this.state.merlinId,
      adiId: this.state.adiId,
      description: IMAGETABLE_DESCRIPTIONS.legacy,
      title: this.state.title,
      __self: this,
      __source: {
        fileName: _jsxFileName,
        lineNumber: 216,
        columnNumber: 37
      }
    })], value === 1 && caps != null && Util.isVisibleForCapabilities(caps, [CAPS.AUDIT]) && /*#__PURE__*/React.createElement(ImageTable, {
      baseUri: BASE_URIS.listImages,
      entityId: this.state.entityId,
      entityProvider: this.state.entityProvider,
      merlinId: this.state.merlinId,
      adiId: this.state.adiId,
      description: IMAGETABLE_DESCRIPTIONS.auditPending,
      title: this.state.title,
      __self: this,
      __source: {
        fileName: _jsxFileName,
        lineNumber: 228,
        columnNumber: 33
      }
    }), value === 2 && caps != null && Util.isVisibleForCapabilities(caps, [CAPS.AUDIT, CAPS.READ]) && /*#__PURE__*/React.createElement(ImageTable, {
      baseUri: BASE_URIS.listImages,
      entityId: this.state.entityId,
      entityProvider: this.state.entityProvider,
      merlinId: this.state.merlinId,
      adiId: this.state.adiId,
      description: IMAGETABLE_DESCRIPTIONS.accepted,
      title: this.state.title,
      __self: this,
      __source: {
        fileName: _jsxFileName,
        lineNumber: 240,
        columnNumber: 33
      }
    }), value === 3 && caps != null && Util.isVisibleForCapabilities(caps, [CAPS.AUDIT, CAPS.READ]) && /*#__PURE__*/React.createElement(ImageTable, {
      baseUri: BASE_URIS.listImages,
      entityId: this.state.entityId,
      entityProvider: this.state.entityProvider,
      merlinId: this.state.merlinId,
      adiId: this.state.adiId,
      description: IMAGETABLE_DESCRIPTIONS.rejected,
      title: this.state.title,
      __self: this,
      __source: {
        fileName: _jsxFileName,
        lineNumber: 252,
        columnNumber: 33
      }
    }), value === 4 && caps != null && Util.isVisibleForCapabilities(caps, [CAPS.PUBLISH]) && /*#__PURE__*/React.createElement(ImageTable, {
      baseUri: BASE_URIS.listImages,
      entityId: this.state.entityId,
      entityProvider: this.state.entityProvider,
      merlinId: this.state.merlinId,
      adiId: this.state.adiId,
      description: IMAGETABLE_DESCRIPTIONS.publishPending,
      title: this.state.title,
      __self: this,
      __source: {
        fileName: _jsxFileName,
        lineNumber: 264,
        columnNumber: 33
      }
    }), value === 6 && caps != null && Util.isVisibleForCapabilities(caps, [CAPS.PUBLISH]) && /*#__PURE__*/React.createElement(ImageTable, {
      baseUri: BASE_URIS.listImages,
      entityId: this.state.entityId,
      entityProvider: this.state.entityProvider,
      merlinId: this.state.merlinId,
      adiId: this.state.adiId,
      description: IMAGETABLE_DESCRIPTIONS.publishFailed,
      title: this.state.title,
      __self: this,
      __source: {
        fileName: _jsxFileName,
        lineNumber: 276,
        columnNumber: 33
      }
    }), value === 5 && /*#__PURE__*/React.createElement(ImageTable, {
      baseUri: BASE_URIS.listImages,
      entityId: this.state.entityId,
      entityProvider: this.state.entityProvider,
      merlinId: this.state.merlinId,
      adiId: this.state.adiId,
      description: IMAGETABLE_DESCRIPTIONS.published,
      title: this.state.title,
      __self: this,
      __source: {
        fileName: _jsxFileName,
        lineNumber: 288,
        columnNumber: 33
      }
    }), value === 7 && /*#__PURE__*/React.createElement(ImageTable, {
      baseUri: BASE_URIS.listExistingImages,
      entityId: this.state.entityId,
      entityProvider: this.state.entityProvider,
      adiId: this.state.adiId,
      merlinId: this.state.merlinId,
      title: this.state.title,
      description: IMAGETABLE_DESCRIPTIONS.existing,
      __self: this,
      __source: {
        fileName: _jsxFileName,
        lineNumber: 300,
        columnNumber: 33
      }
    }), /*#__PURE__*/React.createElement(Footer, {
      merlinId: this.state.merlinId,
      title: this.state.title,
      adiId: this.state.adiId,
      __self: this,
      __source: {
        fileName: _jsxFileName,
        lineNumber: 310,
        columnNumber: 33
      }
    }))))));
  }
  setSelectedImages(qualifier) {
    this.setState({
      selectedImages: qualifier
    });
  }
  makePath() {
    let path = UPDATE_PROGRAM;
    let firstIsSet = false;
    if (this.state.merlinId != null) {
      path += "?".concat(Q_STRING.ENTITY_ID, "=").concat(this.state.merlinId);
      firstIsSet = true;
    } else if (this.state.entityId != null) {
      path += "?".concat(Q_STRING.ENTITY_ID, "=").concat(this.state.entityId);
      firstIsSet = true;
    } else if (this.state.adiId != null) {
      path += "?".concat(Q_STRING.ENTITY_ID, "=").concat(this.state.adiId);
      firstIsSet = true;
    }
    if (this.state.title) {
      path += (firstIsSet ? '&' : '?') + "".concat(Q_STRING.TITLE, "=").concat(this.state.title);
    }
    return path;
  }

  /**
   * Calls TPIS for listImages for the current page. If there are no results in the response, it defaults the page to listLegacyImages
   */
  determineShouldDefaultToLegacyImages() {
    const state = this.state;
    const snackbar = this.snackbar;
    const uri = ImageTable.makeUri(state.entityProvider, state.entityId, state.title, {
      baseUri: BASE_URIS.listImages,
      page: 0,
      pageSize: 10
    });
    if (uri == null) {
      Util.openSnackbar('Unable to look up assets', snackbar);
    }
    Util.fetchWithRedirect(uri, 'GET', this.props).then(resp => {
      if (resp.totalElements == null || resp.totalElements === 0) {
        // Now we have to try again, except this time we're looking for legacy images
        const uri = ImageTable.makeUri(state.entityProvider, state.entityId, state.title, {
          baseUri: BASE_URIS.listLegacyImages,
          page: 0,
          pageSize: 10
        });
        if (uri == null) {
          Util.openSnackbar('Unable to look up assets', snackbar);
        }
        Util.fetchWithRedirect(uri, 'GET', this.props).then(resp => {
          if (resp.totalElements == null || resp.totalElements === 0) {
            // Now, there are no legacy images either
            Util.openSnackbar('There are no images uploaded to this entity through TPIS or the legacy third party image delivery service.', snackbar);
          } else {
            Util.openSnackbar('There were no images uploaded through TPIS. Defaulting to Legacy images', snackbar);
            this.state.selectedImages = DISPLAY_IMAGES.legacy;
            this.forceUpdate();
          }
        });
      }
    }).catch(e => {
      Util.log('SearchResult.determineShouldDefaultToLegacyImages', true, e, false);
    });
  }
  getNewLegacyChips() {
    let selectedImages = this.state.selectedImages;
    return /*#__PURE__*/React.createElement(Grid, {
      style: {
        marginTop: '5px'
      },
      container: true,
      spacing: 1,
      justify: 'center',
      alignItems: 'center',
      alignContent: 'center',
      direction: 'row',
      __self: this,
      __source: {
        fileName: _jsxFileName,
        lineNumber: 402,
        columnNumber: 13
      }
    }, /*#__PURE__*/React.createElement(Grid, {
      item: true,
      alignContent: 'center',
      __self: this,
      __source: {
        fileName: _jsxFileName,
        lineNumber: 404,
        columnNumber: 17
      }
    }, /*#__PURE__*/React.createElement(Typography, {
      align: 'center',
      __self: this,
      __source: {
        fileName: _jsxFileName,
        lineNumber: 405,
        columnNumber: 21
      }
    }, /*#__PURE__*/React.createElement(Chip, {
      label: 'Actionable Images',
      clickable: true,
      onClick: () => this.setSelectedImages('new'),
      variant: selectedImages === DISPLAY_IMAGES.new ? "default" : "outlined",
      __self: this,
      __source: {
        fileName: _jsxFileName,
        lineNumber: 406,
        columnNumber: 25
      }
    }))), /*#__PURE__*/React.createElement(Grid, {
      item: true,
      alignContent: 'center',
      __self: this,
      __source: {
        fileName: _jsxFileName,
        lineNumber: 411,
        columnNumber: 17
      }
    }, /*#__PURE__*/React.createElement(Typography, {
      align: 'center',
      __self: this,
      __source: {
        fileName: _jsxFileName,
        lineNumber: 412,
        columnNumber: 21
      }
    }, /*#__PURE__*/React.createElement(Chip, {
      label: 'Legacy Images',
      clickable: true,
      onClick: () => this.setSelectedImages('legacy'),
      variant: selectedImages === DISPLAY_IMAGES.legacy ? "default" : "outlined",
      __self: this,
      __source: {
        fileName: _jsxFileName,
        lineNumber: 413,
        columnNumber: 25
      }
    }))));
  }
}
export default withStyles(styles)(withRouter(SearchResult));